var map = {
	"./background-blue-1": 8,
	"./background-blue-1.svg": 8,
	"./background-blue-2": 5,
	"./background-blue-2.svg": 5,
	"./background-red-1": 7,
	"./background-red-1.svg": 7,
	"./background-red-2": 6,
	"./background-red-2.svg": 6,
	"./dummy": 10,
	"./dummy-portfolio": 11,
	"./dummy-portfolio.jpg": 11,
	"./dummy.jpg": 10,
	"./mirovni_studiji_21_SD_web": 12,
	"./mirovni_studiji_21_SD_web.png": 12,
	"./ogImage": 13,
	"./ogImage.png": 13,
	"./portfolio1": 14,
	"./portfolio1.png": 14,
	"./portfolio2": 15,
	"./portfolio2.jpg": 15,
	"./portfolio3": 16,
	"./portfolio3.jpg": 16,
	"./portfolio4": 17,
	"./portfolio4.jpg": 17,
	"./slobodnadomena-logo-blue": 2,
	"./slobodnadomena-logo-blue.svg": 2,
	"./slobodnadomena-logo-green": 4,
	"./slobodnadomena-logo-green.svg": 4,
	"./slobodnadomena-logo-red": 3,
	"./slobodnadomena-logo-red.svg": 3
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images ^\.\/.*$
// module id = 24
// module chunks = 0